module.exports = __webpack_public_path__ + "img/DTR.0a36c495.svg";